import { useContext, useState, useMemo, useCallback } from 'react'
import PropTypes from 'prop-types'

import { DataContext } from '@aytm/app/stats/page/sidebar/coding/CodingPanel'

import { getTagsSentimentItemOptionsList } from '@aytm/app/stats/page/comments/lib/utils'

import SettingsButton from '@aytm/app/stats/page/sidebar/coding/components/SettingsButton'

import style from '@aytm/app/stats/page/sidebar/coding/styles/CodingPanel.module.scss'

const TagSettings = ({ tagRef, tag, opened = false, isProcessing = false, isCurrentProcessing = false, onConfirm }) => {
  const { mode, isSentimentsDisabled, onAction, onToggleSettings } = useContext(DataContext)

  const [selectedAction, setSelectedAction] = useState(null)

  const onActionCancel = useCallback(() => setSelectedAction(null), [])

  const onActionConfirm = useCallback(() => {
    onConfirm(selectedAction)
  }, [selectedAction, onConfirm])

  const onActionClick = useCallback(
    action => {
      if ('assign' != action) setSelectedAction(action)
      if (onAction) onAction(action, tag)
    },
    [tag, onAction]
  )

  const onToggle = useCallback(() => onToggleSettings(tag.tag, tag.type, tag.codebook || null), [tag, onToggleSettings])

  const options = useMemo(
    () =>
      getTagsSentimentItemOptionsList({
        specialMode: mode,
        tag,
        selectedAction,
        isSentimentsDisabled,
        onActionCancel,
        onActionConfirm,
        onActionClick
      }),
    [mode, tag, selectedAction, isSentimentsDisabled, onActionCancel, onActionConfirm, onActionClick]
  )

  return 0 < options.length ? (
    <SettingsButton
      itemRef={tagRef}
      options={options}
      opened={opened}
      isProcessing={isProcessing}
      isCurrentProcessing={isCurrentProcessing}
      onActionCancel={onActionCancel}
      onToggle={onToggle}
    />
  ) : (
    <div className={style['component-settings']}></div>
  )
}

TagSettings.propTypes = {
  tagRef: PropTypes.any,
  tag: PropTypes.object,
  opened: PropTypes.bool,
  isProcessing: PropTypes.bool,
  isCurrentProcessing: PropTypes.bool,
  onConfirm: PropTypes.func
}

TagSettings.displayName = 'TagSettings'

export default TagSettings
